import React from 'react';
import { cn } from '../../../utils/classnames';

const sizes = {
  sm: {
    trackWidth: 36,
    trackHeight: 20,
    padding: 2,
    thumbSize: 16,
  },
  md: {
    trackWidth: 44,
    trackHeight: 24,
    padding: 2,
    thumbSize: 20,
  },
  lg: {
    trackWidth: 56,
    trackHeight: 32,
    padding: 4,
    thumbSize: 24,
  },
};

const ToggleSwitch = ({ checked = false, onChange, disabled = false, size = 'sm', className = '' }) => {
  const currentSize = sizes[size] || sizes.md;

  const { trackWidth, trackHeight, padding, thumbSize } = currentSize;

  const translateX = checked ? trackWidth - thumbSize - padding * 2 : 0;

  const handleClick = () => {
    if (disabled) return;
    onChange?.(!checked);
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={handleClick}
      className={cn(
        'relative inline-flex shrink-0 rounded-full',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-bluePale focus-visible:ring-offset-2',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        checked ? 'bg-tealExtraLight3' : 'bg-bluePale',
        className
      )}
      style={{
        width: trackWidth,
        height: trackHeight,
        padding,
        transition: 'background-color 300ms ease-in-out',
      }}
    >
      <span
        className="rounded-full bg-white shadow-sm"
        style={{
          width: thumbSize,
          height: thumbSize,
          transform: `translateX(${translateX}px)`,
          transition: 'transform 300ms ease-in-out',
        }}
      />
    </button>
  );
};

export default ToggleSwitch;
